/** BAM Sections – Accordion, Tabs, Carousel */
(function() {
  'use strict';

  function initAccordion() {
    document.querySelectorAll('[data-bam-accordion-toggle]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var item = this.closest('[data-bam-accordion-item]');
        var isOpen = item.classList.contains('is-open');
        var container = item.closest('.bam-accordion');
        if (container) {
          container.querySelectorAll('[data-bam-accordion-item]').forEach(function(i) {
            i.classList.remove('is-open');
            var t = i.querySelector('[data-bam-accordion-toggle]');
            if (t) t.setAttribute('aria-expanded', 'false');
          });
        }
        if (!isOpen) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function initProductTabs() {
    document.querySelectorAll('[data-bam-product-tabs]').forEach(function(container) {
      var triggers = container.querySelectorAll('[data-bam-tab-trigger]');
      var panels = container.querySelectorAll('[data-bam-tab-panel]');
      triggers.forEach(function(btn, i) {
        btn.addEventListener('click', function() {
          triggers.forEach(function(t, j) {
            t.classList.toggle('is-active', j === i);
            t.setAttribute('aria-selected', j === i);
          });
          panels.forEach(function(p, j) {
            p.classList.toggle('is-active', j === i);
          });
        });
      });
    });
  }

  function initInfoGridModals() {
    document.querySelectorAll('[data-bam-modal-trigger]').forEach(function(trigger) {
      var targetId = trigger.getAttribute('data-bam-modal-target');
      if (!targetId) return;
      var modal = document.getElementById(targetId);
      if (!modal) return;

      function openModal() {
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        trigger.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
        modal.querySelector('.bam-modal__close').focus();
        document.addEventListener('keydown', handleEscape);
      }

      function closeModal() {
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        trigger.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
        trigger.focus();
        document.removeEventListener('keydown', handleEscape);
      }

      function handleEscape(e) {
        if (e.key === 'Escape') closeModal();
      }

      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        openModal();
      });

      modal.querySelectorAll('[data-bam-modal-close]').forEach(function(btn) {
        btn.addEventListener('click', closeModal);
      });

      modal.querySelector('.bam-modal__close').addEventListener('click', closeModal);

      modal.addEventListener('click', function(e) {
        if (e.target === modal || e.target.classList.contains('bam-modal__backdrop')) {
          closeModal();
        }
      });
    });
  }

  function initCarouselAutoplay() {
    document.querySelectorAll('[data-bam-autoplay="true"]').forEach(function(section) {
      var slider = section.querySelector('[data-bam-testimonials], [data-bam-editorial-reviews]');
      if (!slider) return;
      var speed = parseInt(section.getAttribute('data-bam-autoplay-speed') || '5', 10) * 1000;
      var cards = slider.children;
      if (cards.length <= 1) return;
      var index = 0;
      setInterval(function() {
        index = (index + 1) % cards.length;
        var card = cards[index];
        if (card && card.scrollIntoView) {
          card.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        }
      }, speed);
    });
  }

  function init() {
    initAccordion();
    initProductTabs();
    initInfoGridModals();
    initCarouselAutoplay();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', init);
})();
